import {
  BarChartOutlined,
  BoxPlotOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
import { Col, Row, Tooltip, theme } from "antd";
const { useToken } = theme;

const ChartFilter = ({ chartType, updateChartType, chartToHide }) => {
  const { token } = useToken();

  return (
    <Row gutter={[16, 16]} justify="end">
      <Col span={8}>
        <Tooltip title="Time Series Chart">
          {chartToHide && chartToHide === "timeSeries" ? null : (
            <LineChartOutlined
              style={{
                fontSize: "24px",
                color: chartType?.timeSeries ? token.colorPrimary : "#ababab",
                cursor:
                  !chartType?.histogram && !chartType?.boxPlot
                    ? "not-allowed"
                    : "pointer",
              }}
              data-testid={"timeseries-chart-icon"}
              onClick={() =>
                !chartType?.histogram && !chartType?.boxPlot
                  ? null
                  : updateChartType("timeSeries", !chartType.timeSeries)
              }
            />
          )}
        </Tooltip>
      </Col>
      {chartToHide && chartToHide === "histogram" ? null : (
        <Col span={8}>
          <Tooltip title="Histogram Chart">
            <BarChartOutlined
              style={{
                fontSize: "24px",
                color: chartType?.histogram ? token.colorPrimary : "#ababab",
                cursor:
                  !chartType?.timeSeries && !chartType?.boxPlot
                    ? "not-allowed"
                    : "pointer",
              }}
              data-testid={"histogram-chart-icon"}
              onClick={() =>
                !chartType?.timeSeries && !chartType?.boxPlot
                  ? null
                  : updateChartType("histogram", !chartType.histogram)
              }
            />
          </Tooltip>
        </Col>
      )}
      <Col span={8}>
        <Tooltip title="Box Plot Chart">
          <BoxPlotOutlined
            style={{
              fontSize: "24px",
              color: chartType?.boxPlot ? token.colorPrimary : "#ababab",
              cursor:
                !chartType?.timeSeries && !chartType?.histogram
                  ? "not-allowed"
                  : "pointer",
            }}
            data-testid={"boxplot-chart-icon"}
            onClick={() =>
              !chartType?.timeSeries && !chartType?.histogram
                ? null
                : updateChartType("boxPlot", !chartType.boxPlot)
            }
          />
        </Tooltip>
      </Col>
    </Row>
  );
};

export default ChartFilter;
